module.exports = __webpack_public_path__ + "static/media/20.03e21baf.svg";